import { FC, lazy, PropsWithChildren, Suspense } from 'react';

import { OverlayLoader } from 'shared/ui';

const LazyPlanner = lazy(() => import('./Planner'));

export const Planner: FC<PropsWithChildren> = (props) => (
	<Suspense fallback={<OverlayLoader />}>
		<LazyPlanner {...props} />
	</Suspense>
);
